/*
 * Variantify badge fix
 *
 * Variantify clones the first product card client-side for each variant, but it
 * does NOT read the variant-level `custom.badges` metaobject, so every cloned
 * card keeps the original variant's badge.
 *
 * This script reads a per-variant badge map (emitted by
 * snippets/variantify-badge-fix.liquid) and rewrites the badge of each clone
 * based on its `data-variant-id`. Cloned badges are hidden via CSS until this
 * script corrects them, to avoid showing the wrong badge for a frame.
 */
(function () {
  var dataEl = document.querySelector(
    'script[type="application/json"][data-variantify-badges]'
  );
  if (!dataEl) return;

  var BADGES;
  try {
    BADGES = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var BASE_CLASS = dataEl.getAttribute('data-badge-base-class') || '';
  var DONE_ATTR = 'data-variantify-badge-fixed';
  var hasData = BADGES && Object.keys(BADGES).length > 0;

  function buildBadgeHTML(badges) {
    return badges
      .map(function (b) {
        var style =
          '--bg-color: ' + (b.bg || '') + '; --text-color: ' + (b.text || '') + ';';
        return (
          '<span class="' +
          BASE_CLASS +
          ' pg-bg-[var(--bg-color)] pg-text-[var(--text-color)]" style="' +
          style +
          '">' +
          (b.title || '') +
          '</span>'
        );
      })
      .join('');
  }

  function fixCard(card) {
    var variantId = card.getAttribute('data-variant-id');
    if (!variantId) return;

    // Idempotent: skip cards already corrected for their current variant.
    if (card.getAttribute(DONE_ATTR) === variantId) return;

    var badges = hasData ? BADGES[variantId] : null;
    var badgeContainer = card.querySelector('.card__badge');
    if (!badgeContainer) return;

    var inner = badgeContainer.firstElementChild;

    if (badges && inner) {
      inner.innerHTML = badges.length ? buildBadgeHTML(badges) : '';
    }
    // Reveal the (now correct) badge. Even when this variant has no mapping we
    // mark it done so the clone's badge becomes visible instead of staying hidden.
    card.setAttribute(DONE_ATTR, variantId);
  }

  var observer = null;
  var scheduled = false;

  function fixAll() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var cards = grid.querySelectorAll(
      '[data-variantify="clone"][data-variant-id], .variantify-clone[data-variant-id]'
    );
    if (!cards.length) return;

    // Pause the observer while we mutate the DOM to avoid feedback loops.
    if (observer) observer.disconnect();
    cards.forEach(fixCard);
    if (observer) observer.observe(grid, { childList: true, subtree: true });
  }

  function scheduleFix() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      fixAll();
    });
  }

  function init() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    observer = new MutationObserver(scheduleFix);
    observer.observe(grid, { childList: true, subtree: true });
    scheduleFix();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
